import { FunctionComponent, useState, useEffect } from 'react';
import JsonQuery from 'json-query';
import { types as commonTypes, hooks as commonHooks } from '@sitebuilder/common';
// import gqlFactory, { IGraphqlClient } from '../../../graphql';
import { graphql as coreGql } from '@sitebuilder/core';

const CONTENTS_PLACEHOLDER_ID = 'children';

// add local helpers to JsonQuery to use during evaluation
const jsonQuerylocals = {
    substring(input: unknown, start = 0, end?: number) {
        if (typeof input === 'string') {
            return input.substring(start, end);
        }

        return input;
    },
};

function getQueryVariables(
    queryVariables: {
        name: string;
        value: string;
    }[],
    data: Record<string, unknown>
) {
    // const queryVariables = properties.variables as {
    //     name: string;
    //     value: string;
    // }[];
    let variables: Record<string, unknown> = {};

    if (queryVariables && queryVariables.length > 0) {
        variables = queryVariables.reduce(
            (memo, v) => ({
                ...memo,
                [v.name]: JsonQuery(v.value, { data, locals: jsonQuerylocals }).value,
            }),
            {}
        );
    }

    return variables;
}

const getInstanceData = async (
    {
        dataSource,
        scopeData,
        queryVariables,
        expression,
        transform,
        placeHolderExpression,
    }: {
        dataSource: string;
        expression: string;
        transform: string;
        placeHolderExpression: string;
        scopeData: Record<string, unknown>;
        queryVariables: {
            name: string;
            value: string;
        }[];
    },
    graphqlClient: coreGql.IGraphqlClient
) => {
    const query = expression;
    const variables = getQueryVariables(queryVariables, scopeData);
    const extensions: Record<string, unknown> = {};

    if (transform) {
        extensions.transform = transform;
    }

    const data = await graphqlClient.query<Record<string, Record<string, unknown>[]> | undefined>(
        dataSource,
        {
            query,
            variables,
            extensions,
        }
    );

    let returnData: Record<string, unknown>[] = [];

    if (data && placeHolderExpression) {
        const selectedValue = JsonQuery(placeHolderExpression, {
            data,
            locals: jsonQuerylocals,
        }).value;

        if (Array.isArray(selectedValue)) {
            returnData = selectedValue;
        }
    } else if (data && Array.isArray(data[Object.keys(data)[0]])) {
        returnData = data[Object.keys(data)[0]];
    }

    return returnData;
};

const RepeaterTemplateView: FunctionComponent<
    React.PropsWithChildren<commonTypes.WidgetInstanceProps>
> = (props) => {
    const { graphqlClientFactory } = commonHooks.useAppContext();
    const { widgetInstanceId, data } = props;
    const widgetInstance = commonHooks.useWidgetInstance(widgetInstanceId);
    const { inEditMode, accessToken } = commonHooks.useAppContext();
    const [instanceData, setInstanceData] = useState([] as Record<string, unknown>[] | null);
    const { Placeholder } = commonHooks.useAppContext();

    useEffect(() => {
        const params = {
            dataSource: widgetInstance.properties.dataSource as string,
            expression: widgetInstance.properties.expression as string,
            transform: widgetInstance.properties.transform as string,
            placeHolderExpression: widgetInstance.properties.placeHolderExpression as string,
            queryVariables: widgetInstance.properties.variables as {
                name: string;
                value: string;
            }[],
            scopeData: data || {},
        };

        const fetchData = async () => {
            const graphqlClient = graphqlClientFactory.createClient(accessToken || '');

            const result = await getInstanceData(params, graphqlClient);

            if (Array.isArray(result)) {
                setInstanceData(result);
            } else {
                setInstanceData([result || {}]);
            }
        };
        fetchData();
    }, [
        widgetInstance.properties.dataSource,
        widgetInstance.properties.expression,
        widgetInstance.properties.transform,
        widgetInstance.properties.placeHolderExpression,
        widgetInstance.properties.variables,
        data,
        accessToken,
    ]);

    const phData = instanceData && instanceData.length > 0 ? instanceData : [{}];

    return (
        <>
            {inEditMode && <p>Repeater</p>}
            {widgetInstanceId &&
                (phData || []).map((d, i) => (
                    <Placeholder
                        key={i}
                        data={d}
                        contentPlaceHolderId={CONTENTS_PLACEHOLDER_ID}
                        parentWidgetInstanceId={widgetInstanceId}
                    />
                ))}
        </>
    );
};

export default RepeaterTemplateView;
